<template>
    <div class="page-container">
        <!--工具栏-->
        <el-scrollbar>
        <el-form :inline="true" :model="filters" class="demo-form-inline toolbar" style="padding-bottom:0px;" :size="size">
            <el-form-item label="服务名称">
                <el-input v-model.trim="filters.serviceName" placeholder="请输入服务名称" clearable @keyup.enter.native.prevent="enterSearchMember"></el-input>
            </el-form-item>
            <el-form-item label="服务类型">
                <el-select v-model="filters.serviceType" clearable placeholder="请选择服务类型">
                <el-option
                    v-for="item in serviceTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <kt-button icon="el-icon-search" label="查询" type="primary" @click="findPage(null)"/>
            </el-form-item>
            <el-form-item>
                <kt-button icon="el-icon-plus" label="新增" type="warning" @click="handleAdd"/>
            </el-form-item>
            <el-form-item>
                <kt-button icon="el-icon-refresh" label="刷新" type="primary" @click="handleRefresh"/>
            </el-form-item>
        </el-form>
        </el-scrollbar>
        <!--表格内容栏-->
        <kt-table
            v-loading="loading"
            :height="'400'"
            element-loading-text="拼命加载中"
            :data="pageResult"
            :columns="filterColumns"
            :operationWidth="280"
            :showEdit="true"
            :showDelete="true"
            :showLook="true"
            @findPage="findPage"
            @handleEdit="handleEdit"
            @handleDelete="handleDelete"
            @handleLook="handleLook"
            @refreshPageRequest="refreshPageRequest"
        >
        </kt-table>
    </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
export default {
    components: {
        KtTable,
        KtButton
    },
    data() {
        return {
        loading: true,
        serviceTypeOptions: [],
        size: "medium",
        filters: {
            serviceName: "",
            serviceType: ""
        },
        columns: [],
        filterColumns: [],
        pageRequest: { pageNum: 1, pageSize: 10 },
        pageResult: {}
        };
    },
    methods: {
        // 刷新
        handleRefresh() {
            this.filters = {}; //清空查询条件
            this.findPage();
        },
        //键盘事件 按下键盘回车 查询
        enterSearchMember(e){
            console.log('回车搜索',keyCode,e);
            var keyCode = window.event? e.keyCode:e.which;
            if(keyCode==13){
               this.findPage()
            }
        },
        // 获取分页数据   把接口dmc/watch/queryGroupWatchListWithPage 替换成 服务列表接口
        findPage(data) {
        //判断查询条件是否存在
        this.filters.serviceName != undefined ? (this.pageRequest.serviceName = this.filters.serviceName) : (this.pageRequest.serviceName = "");
        this.filters.serviceType != undefined ? (this.pageRequest.serviceType = this.filters.serviceType) : (this.pageRequest.serviceType = "");
        console.log(this.pageRequest);
        this.$postJson("omc/service/queryListWithPage", this.pageRequest).then(res => {
            console.log(res.result);
            res.result.list.forEach(item => {
                console.log(item.serviceType);
                item.serviceType == 0 ? (item.serviceType = "小时") : (item.serviceType = "次");
                switch (item.orderPut) {
                case "admin":
                    item.orderPut = "超级管理员";
                    break;
                case "volunteer":
                    item.orderPut = "志愿者";
                    break;
                default:
                    item.orderPut = "";
                }
                switch (item.orderRecv) {
                case "admin":
                    item.orderRecv = "超级管理员";
                    break;
                case "volunteer":
                    item.orderRecv = "志愿者";
                    break;
                default:
                    item.orderRecv = "";
                }
                switch (item.orderConfirm) {
                case "admin":
                    item.orderConfirm = "超级管理员";
                    break;
                case "volunteer":
                    item.orderConfirm = "志愿者";
                    break;
                default:
                    item.orderConfirm = "";
                }
            });
            this.pageResult = res.result;
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            }).then(data != null ? data.callback : "");
        },

        // 分页刷新数据
        refreshPageRequest(data) {
            console.log(data);
            this.pageRequest.pageNum = data;
            this.findPage();
        },
        // 删除 
        handleDelete(data) {
            console.log(data)
            console.log(data.params[0].id, data.callback);
            let serviceId = data.params[0].id;
            let serviceTimes = data.datainfo.serviceTimes;
            let orderTimes = data.datainfo.orderTimes;
            console.log(serviceId,serviceTimes,orderTimes);
            if (serviceTimes > 0 || orderTimes > 0) {
                this.$message({ message: "此服务正在进行中,无法删除!", type: "error" });
                data.back()
            } else {
                this.$postForm("omc/service/deleteById/" + serviceId).then(res => {
                console.log(res);
                var info = res;
                data.callback(info);
                });
            }
        },

        // 跳转新增界面
        handleAdd() {
            this.$router.push({ path: "/volunteerserviceCompile" }); //编程式导航跳转  query传参
        },
        // 跳转编辑界面
        handleEdit(info) {
            console.log(info);
            let dataForm = Object.assign({}, info.row);
            let data = JSON.stringify(dataForm);
            console.log(dataForm.serviceTimes, dataForm.orderTimes);
            if (dataForm.serviceTimes > 0 || dataForm.orderTimes > 0) {
                //判断serviceTimes和orderTimes大于0就无法修改
                this.$message({ message: "此服务正在进行中,无法修改!", type: "error" });
            } else {
                this.$router.push({ path: "/volunteerserviceCompile", query: { res: data }}); //编程式导航跳转  params传参
            }
        },
        //查看详情
        handleLook(info) {
            console.log(info);
            let dataForm = Object.assign({}, info.row);
            let data = JSON.stringify(dataForm);
            this.$router.push({ path: "/volunteerserviceDetail", query: { res: data }}); //编程式导航跳转  params传参
        },
        // 处理表格列过滤显示
        displayFilterColumnsDialog() {
            this.$refs.tableColumnFilterDialog.setDialogVisible(true);
        },
        // 处理表格列过滤显示
        handleFilterColumns(data) {
            this.filterColumns = data.filterColumns;
            this.$refs.tableColumnFilterDialog.setDialogVisible(false);
        },
        // 处理表格列过滤显示
        initColumns() {
        this.columns = [
            { prop: "serviceName", label: "服务类型名称", minWidth: 130 },
            { prop: "serviceType", label: "类型", minWidth: 120 },
            { prop: "integral", label: "积分兑换情况", minWidth: 130 },
            { prop: "remark", label: "备注", minWidth: 120 },
            { prop: "orderPut", label: "下单人", minWidth: 120 },
            { prop: "createdTime",label: "时间",minWidth: 120}
        ];
            this.filterColumns = JSON.parse(JSON.stringify(this.columns));
        },
        //初始化服务类型
        initialServiceTypes() {
            var serviceTypes = ["小时", "次"];
            for (var i = 0; i < serviceTypes.length; i++) {
                var item = {};
                item.value = i;
                item.label = serviceTypes[i];
                this.serviceTypeOptions.push(item);
            }
        }
    },
    created() {
        this.initialServiceTypes();
    },
    mounted() {
        this.initColumns();
        this.findPage();
    }
};
</script>

<style lang="scss" scoped>
    .avatar-uploader {
        width: 150px;
        height: 150px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 150px;
        height: 150px;
        line-height: 150px;
        text-align: center;
    }
    .avatar {
        width: 150px;
        height: 150px;
        display: block;
    }
    // ::deep深度作用选择符
    ::deep .el-dialog__header {
        text-align: left;
        background: rgb(238, 231, 231);
        border-bottom: 2px solid rgb(211, 207, 207);
    }
    //新增 编辑 dialog
    @media screen and (max-width: 1599px) {
        ::deep .volunteerdialog .el-dialog {
            width: 60% !important;
        }
    }
    ::deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view{
        white-space: nowrap;
        width:100.5%;
        height:100%;
    }
    ::deep .el-form--inline{
        position: relative;
        z-index: 99;
    }
    .filtersposition{
        position: absolute;
        top:10px;
        left:0;
        right:0;
        bottom:10px;
        width:100%;
        height:56px;
        background: #F2F2F2;
        z-index:1;
    }
</style>